<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:m-0 m-4 login-inner">
      <vx-card>
        <div slot="no-body" class="">

          <div class="vx-row no-gutter justify-center items-center">

            <!-- <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
            </div> -->

            <div class="vx-col sm:w-full md:w-full lg:w-full d-theme-dark-bg">
              <div class="p-6 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4 text-center"><img class="mx-auto logo-amacode" src="@/assets/images/logo/main_logo.png" alt="Amacode"></h4>
                  <p class="text-center">ご利用にはAmacode Proへご登録後、サインインが必要です</p>
                  <vs-alert
                  color="primary" active="true" class="mt-3 text-center btn-regist">
                  <a href="https://pro.amacode.app" class="" target="_blank">Amacode Proのお申し込みはこちら</a>
                </vs-alert>
                </div>

                <div class="mt-8">
                  <login-firebase></login-firebase>
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
    <the-footer />
  </div>
</template>

<script>
import LoginFirebase from './LoginFirebase.vue'
import TheFooter from '@/layouts/components/TheFooter.vue'

import firebase from 'firebase/app'
import 'firebase/auth'
import store from '@/store/store'

export default{
  components: {
    LoginFirebase,
    TheFooter
  },
  // error：プロじゃない状態でログインするとエラー
  // 判別した状態でした状態でログアウトさせて、URLパラメータにくっつける、
  // Amacode Proの申込みがされていないアカウントです。申込後、再度ログインをしてください。
  created: function(){
    const appLoading = document.getElementById('app')
    appLoading.classList.add("login-view")

    // ログイン状態かの確認Amacode ProのProフラグチェックをする
    const firebaseCurrentUser = firebase.auth().currentUser
    // ログインしていたら
    if (store.state.auth.isUserLoggedIn()) {
      this.$vs.loading({
        scale: 1,
      })
      const client_id = this.$route.query.client_id

      if (typeof client_id != 'undefined' && client_id != '' && client_id != null) {
        //this.$router.push( { name: 'authorize', query: this.$route.query } )
        appLoading.classList.remove("login-view")
        this.$vs.loading.close()
      }

      // Amacode Proのフラグチェック
      const dbProfileRef = firebase.database().ref('users/' + firebaseCurrentUser.uid + '/setting/ispro')
      dbProfileRef.on('value', (data) => {
        // proフラグがない
        if (!data.val()) {
          appLoading.classList.remove("login-view")
          this.$vs.loading.close()
        } else {
          //appLoading.classList.remove("login-view")
        }
      })
    // ログインしていなかったら
    } else {
      this.$vs.loading.close()
      appLoading.classList.remove("login-view")
    }
  }
}
</script>

<style lang="scss">
  #app{
      &.login-view{
        &:before{
          content:"";
          z-index: 2;
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
          width: 200vw;
          height: 200vh;
          background-color: #fff;
        }
      }
    }
  #page-login {
    .login-inner{
      position: relative;
      z-index: 1;
    }
    .social-login-buttons {
      .bg-facebook { background-color: #1551b1 }
      .bg-twitter { background-color: #00aaff }
      .bg-google { background-color: #4285F4 }
      .bg-github { background-color: #333 }
    }
    .the-footer{
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
  .login-tabs-container {
    //min-height: 505px;

    .con-tab {
      padding-bottom: 14px;
    }

    .con-slot-tabs {
      margin-top: 1rem;
    }
  }
  .logo-amacode{
    width:150px;
    height: auto;
  }
  .btn-regist{
    cursor:pointer;
    a{
      transition: all .25s ease;
    }
    &:before{
      content:"";
      display:block;
      position: absolute;
      top:50%;
      right:15px;
      transform: translate(0,-50%) rotate(45deg);
      width:8px;
      height: 8px;
      border-right: 2px solid rgb(115, 103, 240);
      border-top: 2px solid rgb(115, 103, 240);
      transition: all .25s ease;
    }
    &:hover{
      color:#fff;
      background-color:rgb(115, 103, 240);
      &:before{
        border-color:#fff;
      }
      a{
        color:#fff;
      }
    }
  }
  .btn-danger{
    cursor:pointer;
    a{
      transition: all .25s ease;
    }
    &:before{
      content:"";
      display:block;
      position: absolute;
      top:50%;
      right:15px;
      transform: translate(0,-50%) rotate(45deg);
      width:8px;
      height: 8px;
      border-right: 2px solid rgb(115, 103, 240);
      border-top: 2px solid rgb(115, 103, 240);
      transition: all .25s ease;
    }
    &:hover{
      color:#fff;
      background-color:rgb(115, 103, 240);
      &:before{
        border-color:#fff;
      }
      a{
        color:#fff;
      }
    }
  }

</style>
